import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';

var NAMESPACE = 'td';

var Checkbox = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('label', { staticClass: "td-checkbox", class: { 'is-checked': _vm.checked, 'is-disabled': _vm.disabled, 'is-indeterminate': !_vm.checked && _vm.indeterminate } }, [_c('input', { staticClass: "td-checkbox__inner", attrs: { "type": "checkbox", "disabled": _vm.disabled }, domProps: { "checked": _vm.checked }, on: { "change": _vm.handleChange } }), _vm._v(" "), _c('span', { staticClass: "td-checkbox__label" }, [_vm._t("default")], 2)]);
  }, staticRenderFns: [],
  name: NAMESPACE + '-checkbox',
  props: {
    label: [String, Number],
    value: [Boolean, Array],
    disabled: {
      type: Boolean,
      default: false
    },
    indeterminate: Boolean
  },
  computed: {
    checked: function checked() {
      if (typeof this.value === 'boolean') {
        return this.value;
      } else {
        return this.value.includes(this.label);
      }
    }
  },
  methods: {
    handleChange: function handleChange() {
      var _this = this;

      if (typeof this.value === 'boolean') {
        this.$emit('input', !this.value);
      } else {
        if (this.checked) {
          this.$emit('input', this.value.filter(function (item) {
            return item !== _this.label;
          }));
        } else {
          this.$emit('input', [].concat(_toConsumableArray(this.value), [this.label]));
        }
      }
    }
  }
};

Checkbox.install = function (Vue) {
  Vue.component(Checkbox.name, Checkbox);
};

export default Checkbox;
